import React from 'react'

export default function AgGrid() {
  return (
    <section><a className="anchor" id="agGrid"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/ag-grid.html"><img src="images/ag-theme.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h1>AG Grid - Default</h1>
            <p>Live example of an AG Grid implementation with AG Grid Theme</p>
            <p><a className="btn btn--large" href="samples/ag-grid.html">View live preview</a></p>
          </div>
      </div>

      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/ag-grid-dark.html"><img src="images/ag-theme-dark.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h1>AG Grid - Dark</h1>
            <p>Live example of an AG Grid implementation with AG Grid Dark Theme</p>
            <p><a className="btn btn--large" href="samples/ag-grid-dark.html">View live preview</a></p>
          </div>
      </div>

      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/ag-grid-dark-blue.html"><img src="images/ag-theme-dark-blue.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h1>AG Grid - Dark Blue</h1>
            <p>Live example of an AG Grid implementation with AG Grid Dark Blue Theme</p>
            <p><a className="btn btn--large" href="samples/ag-grid-dark-blue.html">View live preview</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/AgGrid.js